import { Link } from "react-router-dom";
import { ArrowLeft, Heart, Building2, Trophy, PenLine, ExternalLink, Users } from "lucide-react";

const Support = () => (
  <div className="grain min-h-screen" data-testid="support-page">
    <div className="max-w-3xl mx-auto px-6 py-10">
      <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#a39797] hover:text-[#d4af37] mb-8">
        <ArrowLeft size={16} /> back to the file
      </Link>

      <div className="mb-10">
        <div className="font-hand text-[#d4af37] rotate-[-1deg] text-lg mb-2">help us grow</div>
        <h1 className="font-display text-5xl text-[#f4f0ec] mb-3">Help WasntMe.Party grow.</h1>
        <p className="text-[#c7bebe] text-lg max-w-2xl">
          We're an independent studio turning the murder-mystery dinner party into a dynamic,
          personal, digital-first experience. Every bit of support — a buy, a share, or a kind
          word — fuels the next case.
        </p>
      </div>

      {/* 1. Back the project */}
      <div className="mb-10">
        <div className="text-xs tracking-widest text-[#a39797] mb-3">1 · BACK THE PROJECT</div>
        <div className="grid md:grid-cols-2 gap-4">
          <Link to="/founder"
            className="card-noir p-5 hover:border-[#d4af37] transition-colors"
            data-testid="support-founder">
            <Trophy size={16} className="text-[#d4af37] mb-2" />
            <div className="font-display text-xl text-[#f4f0ec]">Become a Founding Member</div>
            <div className="text-sm text-[#a39797] mt-1">
              $99 one-time. Lifetime access to every case we write. Only 100 Founder slots.
            </div>
          </Link>
          <Link to="/club"
            className="card-noir p-5 hover:border-[#d4af37] transition-colors"
            data-testid="support-club">
            <Trophy size={16} className="text-[#d4af37] mb-2" />
            <div className="font-display text-xl text-[#f4f0ec]">Join the Mystery Club</div>
            <div className="text-sm text-[#a39797] mt-1">
              $9/month. 20% off everything + member-only case drops. Cancel anytime.
            </div>
          </Link>
          <a href="https://gofundme.com" target="_blank" rel="noreferrer"
            className="card-noir p-5 hover:border-[#d4af37] transition-colors block"
            data-testid="support-gofundme">
            <Heart size={16} className="text-[#d4af37] mb-2" />
            <div className="font-display text-xl text-[#f4f0ec] inline-flex items-center gap-2">
              Back us on GoFundMe <ExternalLink size={12} />
            </div>
            <div className="text-sm text-[#a39797] mt-1">
              Even $10 helps. Sharing helps even more.
            </div>
          </a>
        </div>
      </div>

      {/* 2. Partner with us */}
      <div className="mb-10">
        <div className="text-xs tracking-widest text-[#a39797] mb-3">2 · PARTNER WITH US</div>
        <div className="grid md:grid-cols-2 gap-4">
          <Link to="/license" className="card-noir p-5 hover:border-[#d4af37] transition-colors"
            data-testid="support-license">
            <Building2 size={16} className="text-[#d4af37] mb-2" />
            <div className="font-display text-xl text-[#f4f0ec]">License a mystery night</div>
            <div className="text-sm text-[#a39797] mt-1">
              Venues, bars, fundraisers. One-event licenses from $249.
            </div>
          </Link>
          <Link to="/for-teams" className="card-noir p-5 hover:border-[#d4af37] transition-colors"
            data-testid="support-teams">
            <Users size={16} className="text-[#d4af37] mb-2" />
            <div className="font-display text-xl text-[#f4f0ec]">Team events</div>
            <div className="text-sm text-[#a39797] mt-1">
              Company offsites, holiday parties, retreats. Starting at $249.
            </div>
          </Link>
          <Link to="/commission" className="card-noir p-5 hover:border-[#d4af37] transition-colors"
            data-testid="support-commission">
            <PenLine size={16} className="text-[#d4af37] mb-2" />
            <div className="font-display text-xl text-[#f4f0ec]">Commission a one-of-one</div>
            <div className="text-sm text-[#a39797] mt-1">
              Hand-written for your group. Weddings, birthdays, bachelorettes. $300-$1,500.
            </div>
          </Link>
          <a href="mailto:sponsors@wasntme.party" className="card-noir p-5 hover:border-[#d4af37] transition-colors block"
            data-testid="support-sponsor">
            <Trophy size={16} className="text-[#d4af37] mb-2" />
            <div className="font-display text-xl text-[#f4f0ec]">Sponsor Global Mystery Night</div>
            <div className="text-sm text-[#a39797] mt-1">
              Put your brand on the New Year's Eve worldwide hunt. Starting at $250.
            </div>
          </a>
        </div>
      </div>

      {/* 3. Investors / lenders */}
      <div className="mb-10">
        <div className="text-xs tracking-widest text-[#a39797] mb-3">3 · INVESTORS &amp; LENDERS</div>
        <div className="card-noir p-6">
          <p className="text-[#c7bebe] mb-3">
            Interested in supporting the business financially? We speak with potential supporters by
            invitation only. Send a short note and we'll be in touch.
          </p>
          <a href="mailto:invest@wasntme.party"
            className="btn-primary text-sm"
            data-testid="support-invest-email">
            Email invest@wasntme.party <ExternalLink size={12} />
          </a>
          <div className="text-[11px] text-[#5a5050] mt-4">
            This page does not offer securities, equity, or returns. Any investment conversation
            happens privately with proper counsel on both sides. Loans are documented in writing.
          </div>
        </div>
      </div>

      <div className="text-center text-xs text-[#5a5050] mt-16">
        Thank you — every day the Vault grows thanks to you.
        <br />
        — the WasntMe.Party crew · a NightBlood Chronicles production
      </div>
    </div>
  </div>
);

export default Support;
